__turbopack_context__.v({
  "className": "roboto_ce49bec6-module__MIZLoq__className",
  "variable": "roboto_ce49bec6-module__MIZLoq__variable",
});
